import config from '../../config';

export function addTenant() {
    return { Tenant: `${config && config.tenant || 'kazup'}` }
}